import React, { useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import DatosEmpresa from './DatosEmpresa';
import DatosRepresentante from './DatosRepresentante';
import EncabezadoRegistro from './EncabezadoRegistro';
import OfertaDemanda from './OfertaDemanda';
import PaginacionRegistro from './PaginacionRegistro';
import Resumen from './Resumen';
import { TerminosCondiciones } from './TerminosCondiciones';
import { Tutorial } from './Tutorial';

function MainRegistro(){

    
    const [badgesRubro, setBadgesRubro]=useState([]); 
    const [badgesOferta, setBadgesOferta]=useState([]); 
    const [badgesDemanda, setBadgesDemanda]=useState([]); 
    const [representantes, setRepresentantes]=useState([]); 
    const [paginaActual, setPaginaActual]=useState(1); 
    const [aceptaTerminos, setAceptaTerminos]=useState(false);

    /*function setDatos(datos, tipo){
        if(tipo === 0)
            setBadgesDemanda(datos);
        if(tipo === 1)
            setBadgesRubro(datos);
        if(tipo === 2)
            setBadgesOferta(datos);
    }*/

    return(  
        <>  
            <div id="containerRegistro" className='container bg-white rounded-4 containerRegistro' >
                <div id="scrollRegistro" className='h-100 scrollArea pt-sm-5 pt-4 px-3 px-sm-2 '>
                    <EncabezadoRegistro idPagina={paginaActual}  />
                    <DatosEmpresa/>
                    <OfertaDemanda setBadgesOferta={setBadgesOferta} badgesOferta={badgesOferta}  
                    badgesDemanda={badgesDemanda}  setBadgesDemanda={setBadgesDemanda} 
                    badgesRubro={badgesRubro} setBadgesRubro={setBadgesRubro}/>
                    <DatosRepresentante representantes={representantes} setRepresentantes={setRepresentantes}/>
                    <TerminosCondiciones className={'mt-4 text-center d-none'} text={'Acepto los Términos y Condiciones'} id={'terminosCondiciones'}
                    terminos={require('../assets/Términos y Condiciones Eventos UI3F.pdf')} value={aceptaTerminos} setValue={setAceptaTerminos}/>
                    <Resumen/>
                    <PaginacionRegistro setPaginaActual={setPaginaActual} paginaActual={paginaActual} badgesRubro={badgesRubro}
                    badgesOferta = {badgesOferta} badgesDemanda={badgesDemanda} representantes={representantes} aceptaTerminos={aceptaTerminos}/>
                </div>
            </div>
            <Tutorial initialId={paginaActual + 1} finalId={paginaActual + 1}/>
        </>
    );
}


export default MainRegistro;